import { paths } from "api/schema/api-schema";
import {} from "@tanstack/react-query";
import assert from "assert";
import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";

const path = "/trs/tool/{id}/";
type ToolId = paths[typeof path]["get"]["parameters"]["path"]["id"];

export const toolGet = djangoClientQueryFactory(
  {
    method: "get",
    path,
  },
  {
    formatInput: (toolId: ToolId) => ({ params: { path: { id: toolId } } }),
    handleResponse: (res) => {
      const tool = res.data;
      assert(tool !== undefined, "Expected tool to be defined in response");

      return tool;
    },
    formatQueryKey: (id) => [id],
  },
);
